const expiredToken = (history: any, err: any, setShowToast: any) => {
  console.log('error')
  if (err.response.status === 401 || err.response.status === 403) {
    if (setShowToast) {
      setShowToast({
        open: 'true',
        type: 'error',
        message: 'Session expired',
      })
    }
    history({pathname: '/'})
    localStorage.removeItem('a')
    localStorage.removeItem('idClient')
    localStorage.removeItem('emailClient')
    return
  }
}

export default expiredToken
